import { defineMessages } from "@/i18n";
import en from "./en";

export const desktopGreetingMessages = defineMessages("desktop-greeting", en);
